<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="图片详情"
    width="550px"
  >
    <!-- <el-carousel :interval="5000" :arrow="list.length>2?'always':'never'" :autoplay="false" class="carousel" @change="changeCarousel">
			<el-carousel-item v-for="item in list" :key="item" class="g-flex g-flex-ac g-flex-cc">

			</el-carousel-item>
		</el-carousel> -->
    <img
      v-for="item in list"
      ref="img"
      :src="item"
      :key="item"
      alt=""
    >
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="handleClose"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        show: false,
        showIndex: 1,
        list: [],
        clientHeight: ''
      };
    },
    computed: {},
    watch: {
      show(v) {
        // setTimeout((item) => {
        // 	console.log(this.$refs.img)
        // 	v ? this.clientHeight = this.$refs.img ? this.$refs.img[0].clientHeight : 600 : '';
        // }, 20)
      }
    },
    mounted() { },
    methods: {
      open() {
        this.show = true;
      },
      handleClose(e) {
        this.show = false;
        this.$emit('close');
      },
      changeCarousel(index) {
        // this.clientHeight = this.$refs.img[index].clientHeight;
        this.showIndex = index + 1;
      }
    },
    destoryed() { }
  };

</script>

<style scoped lang='scss'>
  img {
    display: block;
    margin: 0 auto;
    width: 550px;
  }
</style>



// WEBPACK FOOTER //
// src/directive/img-preview/index.vue